(function () {
  'use strict';
  var root = document.getElementById('buy');
  if (!root) return;

  var card       = root.querySelector('.bb-card');
  var hasPlans   = card.getAttribute('data-has-plans') === 'true';
  var tiers      = [].slice.call(root.querySelectorAll('.tier'));
  var form       = root.querySelector('#bb-form');
  var idInput    = form.querySelector('input[name="id"]');
  var planInput  = form.querySelector('input[name="selling_plan"]');
  var qtyInput   = form.querySelector('input[name="quantity"]');
  var qtyBox     = root.querySelector('.qty input');
  var totalEl    = root.querySelector('.bb-total');
  var renewEl    = root.querySelector('.bb-renew');
  var switchEl   = root.querySelector('.bb-switch');
  var switchLink = switchEl ? switchEl.querySelector('a') : null;
  var sticky     = document.querySelector('.sticky-buy');
  var stickyName = sticky ? sticky.querySelector('.sb-name') : null;
  var stickyPrice= sticky ? sticky.querySelector('.sb-price') : null;

  var subscribing = hasPlans;
  var current = tiers[Math.min(1, tiers.length - 1)] || tiers[0];

  function money(cents) {
    var n = cents / 100;
    return '$' + (Math.round(n * 100) / 100).toFixed(2).replace(/\.00$/, '');
  }
  function qty() {
    var v = parseInt(qtyBox.value, 10);
    if (isNaN(v) || v < 1) v = 1;
    if (v > 99) v = 99;
    return v;
  }
  function unitPrice(t) {
    return subscribing && t.getAttribute('data-sub-price')
      ? parseInt(t.getAttribute('data-sub-price'), 10)
      : parseInt(t.getAttribute('data-price'), 10);
  }
  function wasPrice(t) {
    // struck-through reference: one-time price when subscribing, compare-at otherwise
    if (subscribing) return parseInt(t.getAttribute('data-price'), 10);
    var c = parseInt(t.getAttribute('data-compare'), 10);
    return isNaN(c) || c <= 0 ? 0 : c;
  }

  function paintTier(t) {
    var now = unitPrice(t);
    var was = wasPrice(t);
    var units = parseInt(t.getAttribute('data-units'), 10) || 1;
    t.querySelector('.t-price').textContent = money(now);
    var wasEl = t.querySelector('.t-was');
    if (was > now) { wasEl.textContent = money(was); wasEl.style.display = ''; }
    else { wasEl.style.display = 'none'; }
    t.querySelector('.t-each').textContent = money(Math.round(now / units)) + ' per bar';
    var saveEl = t.querySelector('.t-save');
    if (saveEl) {
      if (was > now) {
        saveEl.style.display = '';
        saveEl.textContent = 'Save ' + Math.round((1 - now / was) * 100) + '%';
      } else {
        saveEl.style.display = 'none';
      }
    }
  }

  function paint() {
    tiers.forEach(function (t) {
      paintTier(t);
      t.setAttribute('aria-pressed', t === current ? 'true' : 'false');
    });

    idInput.value = current.getAttribute('data-variant');
    var plan = current.getAttribute('data-plan');
    planInput.value = (subscribing && plan) ? plan : '';
    if (!planInput.value) planInput.setAttribute('disabled', 'disabled');
    else planInput.removeAttribute('disabled');
    qtyInput.value = qty();

    var total = unitPrice(current) * qty();
    var totalWas = wasPrice(current) * qty();
    totalEl.innerHTML = 'Total: ' + money(total) +
      (totalWas > total ? ' <span class="bb-total-was">' + money(totalWas) + '</span>' : '');

    if (switchLink) {
      switchEl.querySelector('.bb-switch-lead').textContent =
        subscribing ? 'Prefer not to subscribe? ' : 'Want to save more? ';
      switchLink.textContent = subscribing
        ? 'Buy once at the regular price'
        : 'Switch back to subscribe & save';
    }

    var planName = current.getAttribute('data-plan-name');
    if (subscribing && planName) {
      renewEl.textContent = 'Renews automatically — ' + planName + '. Cancel or skip anytime.';
      renewEl.style.display = '';
    } else {
      renewEl.textContent = 'One-time purchase. No subscription.';
      renewEl.style.display = '';
    }

    if (stickyName) {
      stickyName.textContent = current.getAttribute('data-name');
      stickyPrice.textContent = money(total) + (subscribing && planName ? ' · subscription' : ' · one-time');
    }
  }

  tiers.forEach(function (t) {
    t.addEventListener('click', function () { current = t; paint(); });
  });

  root.querySelectorAll('.qty button').forEach(function (b) {
    b.addEventListener('click', function () {
      var step = b.getAttribute('data-step') === '-1' ? -1 : 1;
      qtyBox.value = Math.min(99, Math.max(1, qty() + step));
      paint();
    });
  });
  qtyBox.addEventListener('change', paint);
  qtyBox.addEventListener('input', paint);

  if (switchLink) {
    switchLink.addEventListener('click', function (e) {
      e.preventDefault();
      subscribing = !subscribing;
      paint();
    });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var variantId = idInput.value;
    var planId = planInput.value;
    var body = { id: Number(variantId), quantity: qty() };
    if (subscribing && planId) body.selling_plan = Number(planId);
    function clearCart() {
      return fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: '{}'
      });
    }

    // Clearing first is what makes checkout REPLACE the configuration instead of
    // stacking a second line when a shopper changes their mind. Retry once if the
    // first clear is refused (burst rate-limiting), so a transient 429 can't quietly
    // turn one order into two lines.
    clearCart()
      .then(function (r) {
        if (r && r.ok) return r;
        return new Promise(function (res) { setTimeout(res, 600); }).then(clearCart);
      })
      .catch(function () { /* offline: fall through and still let them buy */ })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        });
      })
      .then(function (r) { if (!r.ok) throw 0; window.location.href = '/checkout'; })
      .catch(function () { form.submit(); });
  });

  if (sticky) {
    var btn = sticky.querySelector('.btn');
    if (btn) btn.addEventListener('click', function (e) {
      e.preventDefault();
      root.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          sticky.classList.toggle('show', !en.isIntersecting && en.boundingClientRect.top < 0);
        });
      }, { threshold: 0 }).observe(card);
    }
  }

  paint();
})();
